import {
  DefaultModalScreenOptions,
  DefaultStackScreenOptions,
  ModalPath,
  ScreenPath,
} from "@/constants/Navigation";
import { Stack } from "@/crossPlatform/expo-router";
import useSendbirdSDK from "@/hooks/useSendbirdSDK";
import { FullScreenSpinner } from "@/ui/core";
import { isWeb } from "@/utils/platform.util";

const Layout = () => {
  const { isSendbirdConnected } = useSendbirdSDK();
  if (isWeb() && !isSendbirdConnected) {
    // on web, show a spinner until sendbird is ready to proceed
    return <FullScreenSpinner />;
  }

  return (
    <Stack screenOptions={DefaultStackScreenOptions}>
      <Stack.Screen name="index" options={DefaultStackScreenOptions} />
      <Stack.Screen
        name={ScreenPath.GroupChannel}
        options={DefaultStackScreenOptions}
      />
      <Stack.Screen
        name={ModalPath.ChannelDetails}
        options={DefaultModalScreenOptions}
      />
      <Stack.Screen
        name={ModalPath.AboutMessages}
        options={DefaultModalScreenOptions}
      />
    </Stack>
  );
};

export default Layout;
